import { FrameRectangle } from '../../../../../../common/components/cart-loader/frame-rectangle/FrameRectangle';
import styles from './ListSummaryLoaderMobile.module.scss';

export const ListSummaryLoaderMobile = ({
  className,
  hideBoxShadow = false,
}: {
  className?: string;
  hideBoxShadow?: boolean;
}) => (
  <div
    className={`
  ${styles['my-list-items-loader-summary-container-mobile']} 
  ${hideBoxShadow && styles['hide-box-shadow']}
  ${className}`}
  >
    <FrameRectangle className={styles['my-list-items-loader-summary-container-mobile-box-1']} />
    <FrameRectangle className={styles['my-list-items-loader-summary-container-mobile-box-2']} />
  </div>
);
